import React from "react";
import { observer } from "mobx-react";
import type { IResourcesStore } from "../../../../resources/ResourcesStore";
import { injectFromApp } from "../../../../shared-components/inject";
import type { StudyInUpload } from "../../../StudyInUpload";
import { RichToolTipComponent } from "../../../../shared-components/rich-tooltip/RichToolTipComponent";
import type { PatientToUpload } from "../../../PatientToUpload";
import { StaticNotificationComponent } from "../../../../shared-components/static-notification/StaticNotificationComponent";

interface IStudyInUploadComponent {
    resourcesStore?: IResourcesStore;
    studyInUpload: StudyInUpload;
    patientToUpload: PatientToUpload;
    canBeRemoved: boolean;
}

@injectFromApp<IStudyInUploadComponent>((stores) => ({
    resourcesStore: stores.resourcesStore,
}))

@observer
export class StudyInUploadComponent extends React.Component<IStudyInUploadComponent> {

    removeStudyInUpload = (event): void => {
        event.stopPropagation();
        const {studyInUpload, patientToUpload} = this.props;
        patientToUpload.removeStudyInUpload(studyInUpload);
    };

    onCommentChange = (event): void => {
        const comment = event.target.value;
        
        if (comment != null && comment.length > 0) {
            this.props.studyInUpload.setComment(comment);
        }
    };

    render() {
        const {resourcesStore, studyInUpload, canBeRemoved} = this.props;
        const {resources} = resourcesStore!;
        const {
            modality,
            studyDescription,
            accessionNumber,
            studyDateFormatted,
            studyTimeFormatted
        } = studyInUpload;
        
        return (
            <StaticNotificationComponent title={ modality + " " + studyDescription } hideIcon={ true } customClass={ "study-to-upload-container label-value-containers-holder" }>
                <div className={ "row" }>
                    <div className={ "label-value-container" }>
                        <div className={ "label-item" }>{ resources.StudyDate }</div>
                        <div className={ "value-item" }>{ studyDateFormatted } { studyTimeFormatted }</div>
                    </div>
                    <div className={ "label-value-container" }>
                        <div className={ "label-item" }>{ resources.AccessionNumber }</div>
                        <div className={ "value-item" }>{ accessionNumber }</div>
                    </div>
                </div>
                <div className={ "label-value-container comment-field" }>
                    <div className={ "input-item" }>
                        <textarea autoCorrect="off"
                                  maxLength={ 256 }
                                  disabled={ !canBeRemoved }
                                  autoCapitalize="off"
                                  spellCheck="false"
                                  placeholder={ resources.OptionalComment }
                                  onChange={ this.onCommentChange }
                        />
                    </div>
                </div>

                { canBeRemoved && (
                    <RichToolTipComponent toolTipResource={ "RemoveStudy" } className={ "remove-study" } onClick={ this.removeStudyInUpload }>
                        &nbsp;
                    </RichToolTipComponent>
                )}
            </StaticNotificationComponent>
        );
    }
}
